<template>
  <v-container
    v-if="shift"
    class="mt-4">
    <v-data-table
      class="border-table"
      density="compact"
      :headers="headers"
      hide-no-data
      item-value="id"
      :items="nonWageLaborCosts">
      <template #item="{ item }">
        <tr>
          <td>
            <CalcInputInline
              field="name"
              :id="item.id" />
          </td>
          <td>
            <CalcInputInline
              field="employers_share_annual_gross_salary_percentage_nonWageLaborCost"
              :id="item.id"
              type="number" />
          </td>
          <td>
            <CalcInputCheckbox
              field="mandatory_nonWageLaborCost"
              :id="item.id" />
            <!-- <BooleanElement :element="item.mandatory_nonWageLaborCost" /> -->
          </td>
          <td class="text-no-wrap">
            <EmbeddedTableActionButtons
              data-cy="nonWageLaborCost"
              :clone-action="() => cloneAction(item.id)"
              :delete-action="() => deleteAction(item.id)" />
          </td>
        </tr>
      </template>

      <!-- Removed pagination, create button -->
      <template #[`header.actions`]>
        <div class="pb-4">
          <v-btn
            class="mx-1 px-0 mt-4"
            color="#ECE6F0"
            elevated="26"
            max-width="40"
            min-width="40"
            rounded="lg"
            data-cy="add-element-nonWageLaborCost"
            @click="addAction">
            <v-icon
              color="#0F6DAC"
              size="x-large">
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
    <template v-if="shift" />
  </v-container>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useTranslation } from "i18next-vue";
import EmbeddedTableActionButtons from "@/components/DataTable/EmbeddedTableActionButtons.vue";
import { useSpaceStore } from "@/stores/spaceStore";
import { useRouter } from "vue-router";
import CalcInputInline from "@/components/Elements/CalcInputInline.vue";
import CalcInputCheckbox from "@/components/Elements/CalcInputCheckbox.vue";

const props = defineProps({
  shiftId: {
    type: String,
    required: true
  }
});

const { t } = useTranslation();
const spaceStore = useSpaceStore();

const popupForm = ref(false);

const shift = ref(null);

onMounted(() => {
  shift.value = spaceStore.calculationElements[props.shiftId];
});

const headers = computed(() => [
  {
    title: t("entities.nonWageLaborCost.fields.name"),
    align: "start",
    sortable: false,
    key: "name"
  },
  {
    title: t(
      "entities.nonWageLaborCost.fields.employers_share_annual_gross_salary_percentage_nonWageLaborCost"
    ),
    key: "description",
    sortable: false,
    width: "200px"
  },
  {
    title: t("entities.nonWageLaborCost.fields.mandatory_nonWageLaborCost"),
    key: "mandatory_nonWageLaborCost",
    sortable: false
  },
  {
    title: "",
    key: "actions",
    sortable: false,
    align: "end"
  }
]);

const nonWageLaborCosts = computed(() => {
  return Object.entries(spaceStore.calculationElements).reduce(
    (result, [id, element]) => {
      if (
        id.endsWith("nonWageLaborCost") &&
        spaceStore.calculationElements[props.shiftId].children.includes(id)
      ) {
        result.push(Object.assign({}, element, { id }));
      }
      return result;
    },
    []
  );
});

const router = useRouter();

const addAction = () => {
  spaceStore.createElement("nonWageLaborCost", props.shiftId);
};

const cloneAction = (id) => {
  spaceStore.prepareClone(id);
  spaceStore.cloneOnServer(props.shiftId, false);
};

const deleteAction = (id) => {
  spaceStore.removeElement(id);
};
</script>
